import { html } from "lit";
import { authConfig } from "../../../.storybook/Auth";

export default {
    title: "Components/Onboarding Guide",
    component: "ux-iws-onboarding-guide",
    args: {},
    argTypes: {},
    parameters: {
        docs: {
            source: {
                excludeDecorators: true,
            },
        },
    },
    decorators: [
        (story, context) => {
            const isDocsMode = context.viewMode === "docs";

            if (!isDocsMode) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "visible";
            }

            return html`<div style="min-height: 800px;">
                ${story()}
                <ux-u-silent-auth
                    client-id="${authConfig.clientId}"
                    client-name="mytrumpf"
                    issuer="https://identity-s.trumpf.com"
                    scope="openid"
                >
                </ux-u-silent-auth>
            </div>`;
        },
    ],
};

const TemplateDefault = () =>
    html` <ux-iws-onboarding-guide
        data-endpoint="generated-mock-data/onboarding-guide.json"
        opened
    >
    </ux-iws-onboarding-guide>`;

const TemplateScriptTag = () => html`
    <ux-iws-onboarding-guide data-script-id="onboarding-guide-data" opened>
    </ux-iws-onboarding-guide>
    <script type="application/json" id="onboarding-guide-data">
        {
            "buttonProgressBar": {
                "label": "Erste Schritte",
                "variant": "no-border"
            },
            "buttonPrev": {
                "label": "Zurück"
            },
            "buttonNext": {
                "label": "Weiter"
            },
            "buttonRememberLogin": {
                "label": "Beim nächsten Login erinnern",
                "url": "generated-mock-data/onboarding-guide-remember-login.json"
            },
            "buttonNeverShowAgain": {
                "label": "Nie wieder anzeigen",
                "url": "generated-mock-data/onboarding-guide-never-show-again.json"
            },
            "buttonStartGuide": {
                "label": "Let's Go",
                "variant": "primary"
            },
            "buttonCloseGuide": {
                "label": "Nicht wieder anzeigen"
            },
            "buttonFinishGuide": {
                "label": "Onboarding beenden",
                "variant": "primary"
            },
            "steps": [
                {
                    "type": "intro",
                    "headline": "Hallo Taylor,",
                    "text": "<p>Mit Ihrer Maschine erhalten Sie Zugang zu kostenlosen Elementen des digitalen Ökosystems von TRUMPF. Entdecken Sie wertvolle Funktionen rund um Ihre Fertigung, die Ihre tägliche Arbeit erleichtern und optimieren.</p><p>Nehmen Sie sich kurz Zeit, um sich mit den Möglichkeiten vertraut zu machen und sie nach ihren Wünschen einzurichten.</p>",
                    "hint": "Weitere Informationen zu Ihren Maschinen, finden Sie auf den jeweiligen Maschinendetailseiten.",
                    "machines": [
                        {
                            "name": "TRULASER 3030 FIBER",
                            "number": "A0200S0007",
                            "imageSrc": "https://api-s.trumpf.com/asset-management/1.0/images/asset-types/TRBV85SX/media/images/TB%20V%2085%20S_08_03_RGB.jpg"
                        },
                        {
                            "name": "TRULASER 3031 FIBER",
                            "number": "A0200S0007",
                            "imageSrc": "https://api-s.trumpf.com/asset-management/1.0/images/asset-types/TRBV85SX/media/images/TB%20V%2085%20S_08_03_RGB.jpg"
                        },
                        {
                            "name": "TRULASER 3032 FIBER",
                            "number": "A0200S0007",
                            "imageSrc": "https://api-s.trumpf.com/asset-management/1.0/images/asset-types/TRBV85SX/media/images/TB%20V%2085%20S_08_03_RGB.jpg"
                        },
                        {
                            "name": "TRULASER 3033 FIBER",
                            "number": "A0200S0007",
                            "imageSrc": "https://api-s.trumpf.com/asset-management/1.0/images/asset-types/TRBV85SX/media/images/TB%20V%2085%20S_08_03_RGB.jpg"
                        },
                        {
                            "name": "TRULASER 3034 FIBER",
                            "number": "A0200S0007",
                            "imageSrc": "https://api-s.trumpf.com/asset-management/1.0/images/asset-types/TRBV85SX/media/images/TB%20V%2085%20S_08_03_RGB.jpg"
                        },
                        {
                            "name": "TRULASER 3035 FIBER",
                            "number": "A0200S0007",
                            "imageSrc": "https://api-s.trumpf.com/asset-management/1.0/images/asset-types/TRBV85SX/media/images/TB%20V%2085%20S_08_03_RGB.jpg"
                        }
                    ],
                    "mediaElements": [
                        {
                            "type": "video",
                            "url": "./mock-assets/videos/lets-go-animated-wireframe.mp4",
                            "caption": "Den Rundgang jederzeit wieder aufrufen"
                        }
                    ]
                },
                {
                    "type": "table-of-contents",
                    "headline": "Inhaltsverzeichnis",
                    "text": "<p>Alle wichtigen Themen für Ihren Start haben wir hier übersichtlich zusammengestellt. Klicken Sie auf die Bereiche, um loszulegen. Zum Überblick gelangen Sie über das Icon oben links.</p>"
                },
                {
                    "type": "content",
                    "headline": "Service App",
                    "subline": "Ihr Draht zu uns, Servicefalle schneller melden",
                    "text": "<p>Der schnellste Weg zum Technischen Kundendienst. Bei Problemen mit Ihrer TRUMPF Maschine oder Ihrer Software muss es schnell gehen: Nutzen Sie die TRUMPF Service App, um Ihre Servicefälle rund um die Uhr an unseren technischen Kundendienst zu übermitteln – entweder per App oder in der Desktopversion.</p><p>Laden Sie jetzt die Service App herunter.</p>",
                    "mediaElements": [
                        {
                            "type": "image",
                            "url": "./mock-assets/images/onboarding-guide/intro.jpg",
                            "alt": "Media Alt",
                            "caption": "<p>Den Rundgang jederzeit wieder aufrufen<p><p>Zweizeilig Caption<p>"
                        },
                        {
                            "type": "image",
                            "url": "./mock-assets/images/onboarding-guide/intro.jpg",
                            "alt": "Media Alt",
                            "caption": "<Den Rundgang jederzeit wieder aufrufen"
                        },
                        {
                            "type": "image",
                            "url": "./mock-assets/images/onboarding-guide/intro.jpg",
                            "alt": "Media Alt",
                            "caption": "<Den Rundgang jederzeit wieder aufrufen"
                        },
                        {
                            "type": "image",
                            "url": "./mock-assets/images/onboarding-guide/intro.jpg",
                            "alt": "Media Alt",
                            "caption": "<Den Rundgang jederzeit wieder aufrufen"
                        },
                        {
                            "type": "image",
                            "url": "./mock-assets/images/onboarding-guide/intro.jpg",
                            "alt": "Media Alt",
                            "caption": "<Den Rundgang jederzeit wieder aufrufen"
                        },
                        {
                            "type": "image",
                            "url": "./mock-assets/images/onboarding-guide/intro.jpg",
                            "alt": "Media Alt",
                            "caption": "<Den Rundgang jederzeit wieder aufrufen"
                        },
                        {
                            "type": "image",
                            "url": "./mock-assets/images/onboarding-guide/intro.jpg",
                            "alt": "Media Alt",
                            "caption": "<Den Rundgang jederzeit wieder aufrufen"
                        },
                        {
                            "type": "image",
                            "url": "./mock-assets/images/onboarding-guide/intro.jpg",
                            "alt": "Media Alt",
                            "caption": "<Den Rundgang jederzeit wieder aufrufen"
                        }
                    ]
                },
                {
                    "type": "content",
                    "headline": "Punch Guide",
                    "subline": "Stanzwissen für jeden Anwendungsfall",
                    "text": "<p>Profitieren Sie von jahrzehntelanger Erfahrung im Stanzbereich.</p><p>Der TRUMPF PunchGuide bietet Ihnen einen Baukasten voller Ideen, Wissen und Tipps aus der Stanzpraxis.</p><p>Jetzt von der Anwendungsvielfalt der Stanzwerkzeuge inspirieren lassen und den PunchGuide unter Favoriten abspeichern.</p>",
                    "hint": "",
                    "mediaElements": [
                        {
                            "type": "image",
                            "url": "./mock-assets/images/onboarding-guide/punch-guide.jpg",
                            "alt": "",
                            "caption": ""
                        }
                    ],
                    "buttons": [
                        {
                            "label": "Bend Guide öffnen",
                            "url": "#",
                            "variant": "primary"
                        }
                    ]
                },
                {
                    "type": "content",
                    "headline": "Smart View für Werkzeugmaschinen",
                    "subline": "Transparenz für Ihre Fertigung",
                    "text": "<p>Verschaffen Sie sich Transparenz zu Ihrer Maschine auf dem Shopfloor und untermauern Sie Ihre Entscheidungen mit Daten.</p><p>Führen Sie Analysen zu Performance und Betriebszuständen durch und identifizieren Sie Trends.</p><p>Jetzt Smart View öffnen und Überblick verschaffen.</p>",
                    "hint": "",
                    "mediaElements": [
                        {
                            "type": "image",
                            "url": "./mock-assets/images/onboarding-guide/smart-view.jpg",
                            "alt": "",
                            "caption": ""
                        }
                    ],
                    "buttons": [
                        {
                            "label": "Smart View öffnen",
                            "url": "#",
                            "variant": "primary"
                        }
                    ]
                },
                {
                    "type": "content",
                    "headline": "Online Updates",
                    "subline": "Abonnieren Sie Softwareupdates für Ihre Maschine",
                    "text": "<p>Profitieren Sie kostenfrei von Online Updates für Ihre Maschine und verwalten Sie Ihre Updateeinstellungen eigenständig in MyTRUMPF.</p><p>Sobald Updates auf der Maschine verfügbar sind, können Sie diese individuell starten.</p>",
                    "hint": "",
                    "mediaElements": [
                        {
                            "type": "video",
                            "url": "./mock-assets/videos/lets-go-animated-online-security-layout.mp4",
                            "caption": ""
                        }
                    ],
                    "buttons": [
                        {
                            "label": "Update Einstellung",
                            "url": "#",
                            "variant": "primary"
                        },
                        {
                            "label": "Mehr erfahren",
                            "url": "#"
                        }
                    ]
                },
                {
                    "type": "content",
                    "headline": "Learning Nuggets",
                    "subline": "Lernen leicht gemacht, Nugget für Nugget.",
                    "text": "<p>Unsere kostenfreie Learning Nuggets bieten schnelle Hilfe bei Performance-Problemen durch fehlerhafte Bedienung oder Wartung der Maschine. Die kompakten Schulungseinheiten bieten direkte Anleitungen zur Fehlerbehebung und ermöglichen Ihnen, akute Probleme selbstständig zu lösen.</p><p>Profitieren Sie jetzt durch Ihren Wissenszuwachs.</p>",
                    "hint": "",
                    "mediaElements": [
                        {
                            "type": "image",
                            "url": "./mock-assets/images/onboarding-guide/learning-nuggets.jpg",
                            "alt": "",
                            "caption": ""
                        }
                    ],
                    "buttons": [
                        {
                            "label": "Zu Learning Nuggets",
                            "url": "#",
                            "variant": "primary"
                        }
                    ]
                },
                {
                    "type": "content",
                    "headline": "Ihr Machinenpark",
                    "subline": "Assets verwalten",
                    "text": "<p>Ihre Maschine wurde in Ihren Maschinenpark aufgenommen. Erhalten Sie wertvolle Informationen rund um Ihre Maschine und verwalten Sie Ihre Assets.</p>",
                    "hint": "",
                    "mediaElements": [
                        {
                            "type": "image",
                            "url": "./mock-assets/images/onboarding-guide/punch-guide.jpg",
                            "alt": "",
                            "caption": ""
                        }
                    ],
                    "buttons": [
                        {
                            "label": "Zu meinen Maschinen",
                            "url": "#",
                            "variant": "primary"
                        }
                    ]
                },
                {
                    "type": "content",
                    "headline": "Sonderaktion Optimate",
                    "subline": "",
                    "text": "<p>Lernen Sie Optimate kennen und optimieren Sie Ihre Konstruktionen.</p>",
                    "hint": "",
                    "mediaElements": [
                        {
                            "type": "video",
                            "url": "./mock-assets/videos/mytrumpf-customer-success-short-steinhart-de.mp4",
                            "alt": "",
                            "caption": ""
                        }
                    ],
                    "buttons": [
                        {
                            "label": "Zu Optimate",
                            "url": "#",
                            "variant": "primary"
                        }
                    ]
                },
                {
                    "type": "content",
                    "headline": "Ihre Sonderaustattung",
                    "subline": "",
                    "text": "<p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</p>",
                    "hint": "",
                    "mediaElements": [
                        {
                            "type": "video",
                            "url": "./mock-assets/videos/mytrumpf-customer-success-short-steinhart-de.mp4",
                            "alt": "",
                            "caption": ""
                        },
                        {
                            "type": "image",
                            "url": "./mock-assets/images/onboarding-guide/learning-nuggets.jpg",
                            "alt": "",
                            "caption": ""
                        }
                    ],
                    "buttons": [
                        {
                            "label": "Zu den Sonderausstattungen",
                            "url": "#",
                            "variant": "primary"
                        }
                    ]
                }
            ]
        }
    </script>
`;

export const DataEndpoint = TemplateDefault.bind({});
DataEndpoint.args = {};

export const DataScriptTag = TemplateScriptTag.bind({});
DataScriptTag.args = {};
